import TableViewContent from './TableViewContent';

export default TableViewContent;